export const config = {
    apiUrl: '',
    //apiUrl: 'http://localhost:4534',
    //apiUrl: 'https://localhost:44312',
    isLoggedIn: localStorage.getItem('user') != null ? true : false,
    isFirstLunch: true
};